import { awsRum } from "./AwsRum";
import * as Sentry from "@sentry/react";

export const logger = {
  /**
   * Logs an error to the Sentry, console AWS RUM
   * @param err An Error to log
   */
  error(err: Error | unknown) {
    if (!(err instanceof Error)) {
      err = new Error(JSON.stringify(err));
    }
    console.error(err);
    awsRum.recordError(err);
    Sentry.captureException(err);
  },
};
